import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import EditIcon from "../../Assets/OptionsModel/edit.svg";
import DeleteIcon from "../../Assets/OptionsModel/Delete.svg";
import ViewIcon from "../../Assets/OptionsModel/View.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { setModal, setSelectedKebabItem } from '../../Features/collectionsSlice';

function KebabMenu({ boxRef, collection }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [visible, setVisible] = useState(false);

    const collectionKebabOpen = useSelector((state) => state.collections.collectionKebab.kebabOpen);

    const handleViewCategory = () => {
        navigate(`${location.pathname}/collection/${collection.id}`);
    }

    const handleEdit = () => {
        navigate(`${location.pathname}/collection/edit-collection/${collection.id}`);
    }

    const handleDelete = (e) => {
        e.stopPropagation();
        dispatch(setSelectedKebabItem(collection));
        dispatch(setModal('delete-confirm'));
    }

    useEffect(() => {
        if(collectionKebabOpen) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [collectionKebabOpen]);

    return (
        <div ref={boxRef} className={`${visible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all duration-150 ease-in-out bg-[#FFFFFF] absolute z-10 w-32 top-6 right-12 flex flex-col gap-0 shadow-[0px_0px_12px_0px_#0000003D] rounded-md overflow-hidden`}>
            <button onClick={handleViewCategory} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={ViewIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>View</p>
            </button>

            <button onClick={handleEdit} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={EditIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>Edit</p>
            </button>

            <button onClick={handleDelete} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={DeleteIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>Delete</p>
            </button>
        </div>
    );
}

export default KebabMenu;
